import { flex, stack } from "@styled-system/patterns";

export const wrapperClass = stack({
	width: "full",
	gap: "12",
	marginTop: "24",
});

export const fieldWrapperClass = flex({
	gap: "8",
	"& > div": {
		width: "full",
	},
});
